module.exports = __webpack_public_path__ + "static/media/Alexander-Ma.9eb193b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/Alexander-Ma.jpg
// module id = 99
// module chunks = 0